import SectionHeading from "@/components/SectionHeading";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/constants/site";

export default function Faq() {
  return (
    <section id="faq" className="bg-white py-20 sm:py-28" data-testid="faq-section">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          number="05"
          caption="Straight Answers"
          title="Questions? We've Heard Them All."
          align="center"
        />

        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="rounded-xl border border-slate-200 bg-[#FAFAFA] px-5 transition-colors duration-200 data-[state=open]:border-rescue/40 data-[state=open]:bg-white sm:px-6"
            >
              <AccordionTrigger
                data-testid={`faq-item-${i}`}
                className="py-5 text-left font-display text-base font-bold text-navy hover:no-underline sm:text-lg"
              >
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 font-mono text-xs font-bold text-rescue">
                    Q{String(i + 1).padStart(2, "0")}
                  </span>
                  {faq.q}
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-5 pl-8 text-sm leading-relaxed text-slate-600 sm:text-base">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
